import { handleActions } from 'redux-actions';
import { push } from "react-router-redux";
import { initialize as initializeForm } from 'redux-form';
import { NotificationManager } from "react-notifications";
import { api } from "api";
import Swal from 'sweetalert2';

const LISTADO_DISTRIBUIDOR = 'LISTADO_DISTRIBUIDOR';
const LOADER = 'LOADER';
const MODULO = 'MODULO';
const LISTADO_CENTRO_COSTO = 'LISTADO_CENTRO_COSTO';
const LECTURA = 'LECTURA';
const PAIS_LIST = 'PAIS_LIST';

const setLoader = loader => ({
    type: LOADER,
    loader,
});

export const listar = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    let params = { id };
    dispatch(setLoader(true));
    api.get('/distribuidor/distribuidor', params).then((response)=>{
        dispatch({ type: LISTADO_DISTRIBUIDOR, data: response });
    }).catch(()=>{
        NotificationManager.error(
            'Ocurrió un error al listar distribuidores',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const registroDistribuidor = () => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const data = getStore().form.FormDistribuidorVM.values;
    let id_empresa = id_emp[5];

    if (data === undefined){
        Swal.fire({
            title: 'Distribuidor',
            text: 'Debe de ingresar datos',
            type: 'error',
        })
    }else {
        if (data.nombre === undefined || data.nombre === ''){
            Swal.fire({
                title: 'Distribuidor',
                text: 'Debe de ingresar nombre',
                type: 'error',
            })
        }else {
            if (data.centro_costo === undefined || data.centro_costo === ''){
                Swal.fire({
                    title: 'Distribuidor',
                    text: 'Debe de seleccionar centro de costo',
                    type: 'error',
                })
            }else {
                if (data.cuenta === undefined || data.cuenta === ''){
                    Swal.fire({
                        title: 'Producto',
                        text: 'Debe de ingresar cuenta contable',
                        type: 'error',
                    })
                }else {
                    const formData = {
                        nombre: data.nombre,
                        direccion: data.direccion,
                        centro_costo: data.centro_costo,
                        cuenta: data.cuenta.value,
                        empresa: id_empresa,
                        pais: data.pais
                    }
                    dispatch(setLoader(true));
                    api.post('/distribuidor/distribuidor/', formData).then(() => {
                        NotificationManager.success(
                            'Distribuidor creado',
                            'Exito',
                            3000
                        );
                        let ruta = `/visitador_medico/${id_emp[5]}/distribuidor`
                        dispatch(push(ruta));
                    }).catch((error) => {
                        NotificationManager.error(
                            error.msj,
                            'Error',
                            2000
                        );
                    }).finally(() => {
                        dispatch(setLoader(false));
                    });
                }
            }
        }
    }
}

export const modificarDistribuidor = () => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const datos = getStore().form.FormDistribuidorVM.values;
    console.log(datos)
    const id = datos.id;
    if (datos.nombre === undefined || datos.nombre === ''){
        Swal.fire({
            title: 'Distribuidor',
            text: 'Debe de ingresar nombre',
            type: 'error',
        })
    }else {
        let centro_costo = datos.centro_costo_mod;
        if (centro_costo === undefined){
            centro_costo = datos.centro_costo;
        }else{
            centro_costo = datos.centro_costo_mod;
        }
        let cuentaContable = datos.cuenta_mod;
        if (cuentaContable === undefined){
            cuentaContable = datos.cuenta_contable;
        }else{
            cuentaContable = datos.cuenta_mod.value;
        }
        const formData = {
            id: id,
            nombre: datos.nombre,
            direccion: datos.direccion,
            centro_costo: centro_costo,
            cuenta: cuentaContable,
            pais: datos.pais,
            empresa: id_emp[5]
        }
        dispatch(setLoader(true));
        api.put(`/distribuidor/distribuidor/${id}/`, formData).then(() => {
            NotificationManager.success(
                'Distribuidor modificado correctamente',
                'Exito',
                3000
            );
            let ruta = `/visitador_medico/${id_emp[5]}/distribuidor`
            dispatch(push(ruta));
        }).catch((error) => {
            NotificationManager.error(
                error.msj,
                'Error',
                2000
            );
        }).finally(() => {
            dispatch(setLoader(false));
        });
    }
}

export const leer = (id) => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`/distribuidor/distribuidor/${id}`).then((response) => {
        dispatch(initializeForm('FormDistribuidorVM', response ));
        dispatch({ type: LECTURA, lectura: response });
    }).catch(()=>{
        NotificationManager.error(
            'Ocurrió un error al consultar distribuidor',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });

}

export const getModulo = (id, modulo) => (dispatch) => {
    const params = {id, modulo}
    dispatch(setLoader(true));
    api.get('/modulos/modulo/', params).then((response)=>{
        dispatch({ type: MODULO, modulo: response.modulos });
    }).catch(() => {
        if (error.status === 401){
            NotificationManager.error(
              error.body.msj,
              'Error',
              0
            );
        }
        if (error.status === 400){
            NotificationManager.error(
              'Ocurrió un error en buscar modulo',
              'Error',
              0
            );
        }
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

export const listarCentroCosto = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const params = {id}
    api.get('/visitador_medico/centro_costo/',params).then(data=>{
        const list_centros = [];
        if(data){
            data.forEach(item=>{
                list_centros.push({
                    value: item.id,
                    label: item.codigo + ' -- ' + item.descripcion
                })
            })
        }
        dispatch({ type: LISTADO_CENTRO_COSTO, listaCentros: list_centros });
    }).catch(()=>{
        return [];
    })
}

export const listarCuentasContables = (search) => () => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const params = {id, search}
    return api.get('/distribuidor/cuenta_contable_distribuidor/',params).then(data=>{
        const list_cuentas = [];
        if(data){
            data.forEach(item=>{
                list_cuentas.push({
                    value: item.id,
                    label: item.cuenta + ' -- ' + item.nombre
                })
            })
        }
        return list_cuentas;
    }).catch(()=>{
        return [];
    })
}

export const paisList = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let empresa = id_emp[5];
    
    return api.get(`/pais_colaborador/pais_empresa/?id=${empresa}`).then((data)=>{
        const pais = [];
        data.results.forEach(item=>{
            pais.push({
                value: item.id,
                label: item.pais
            })
        })
        dispatch({ type: PAIS_LIST, pais: pais });
    }).catch(error=>{
        NotificationManager.error(
            'Ocurrió un error al listar paises',
            'Error',
            0
        );
    })
}

export const actions = {
    listar,
    registroDistribuidor,
    modificarDistribuidor,
    leer,
    getModulo,
    listarCentroCosto,
    listarCuentasContables,
    paisList
};

export const reducers = {
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [LISTADO_DISTRIBUIDOR]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [MODULO]: (state, { modulo }) => {
        return {
            ...state,
            modulo,
        };
    },
    [LISTADO_CENTRO_COSTO]: (state, { listaCentros }) => {
        return {
            ...state,
            listaCentros,
        };
    },
    [LECTURA]: (state, { lectura }) => {
        return {
            ...state,
            lectura,
        };
    },
    [PAIS_LIST]: (state, { pais }) => {
        return {
            ...state,
            pais,
        };
    },
};

export const initialState = {
    loader: false,
    modulo: [],
    data: [],
    listaCentros: [],
    lectura: [],
    pais: [],
};

export default handleActions(reducers, initialState)
 